module.exports = __webpack_public_path__ + "img/58_13.f72aa64f.png";